export default __webpack_public_path__ + "static/logo-2c09ac1a73d1f9d04eea102ce1bb8b79.png";